import React from 'react';
import PropTypes from 'prop-types';
import styles from './instoreCollection.module.scss';

const HeaderSection = ({ isMobile, storeSelection }) => (
  <div className={styles.header}>
    <div className={styles.headerLeftSection}>
      <h1>Cobrar</h1>
      {!isMobile && <p>Aquí puedes cobrar y revisar las órdenes del día.</p>}
    </div>
    {storeSelection && (
      <div className={styles.headerRightSection}>{storeSelection}</div>
    )}
  </div>
);

HeaderSection.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  storeSelection: PropTypes.node,
};

export default HeaderSection;
